import React, { memo, Suspense } from "react";
import styles from "./PreLogin.module.scss";
import { Outlet } from "react-router-dom";
import Loader from "@/components/Loader/Loader";

const PreLogin = () => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.main_img}>
        <div className={styles.main_img_content}>
          <div className={styles.headingDiv}>
            <p className={styles.heading}>The network for wedding creatives</p>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loader />}>
        <span className={styles.childrenContainer}>
          <Outlet />
        </span>
      </Suspense>
    </div>
  );
};

export default memo(PreLogin);
